export default function NoticeBanner({ message, errors }) {
  return <div style={styles.container}>
    {message && <span style={styles.title}>{message}</span>}
    {errors && (
      <ul style={styles.list}>
        {errors.map(({ message }) => (
          <li>{message}</li>
        ))}
      </ul>
    )}
  </div>
}

const styles = {
  container: {
    color: '#ff9800',
    backgroundColor: '#fff3e0',
    padding: 12,
    borderRadius: 6,
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    marginBottom: '16px',
  },
  title: {
    fontWeight: 'bold',
  },
  list: {
    color: '#000',
    marginLeft: 16,
    fontSize: 14,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  }
};
